import styled from 'styled-components';
import SwitchiOS from '../../../../components/SwitchiOS';
import { theme } from '../../../../styles/theme';

const Container = styled.div<{ $disabled: boolean }>`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  font-size: 10px;
  align-items: center;
  column-gap: 8px;
  ${({ $disabled }) => $disabled && `color: ${theme.colors.secondary400}`};
`;
export const AdvancedSearchDisabledSchemas = ({
  onClick,
  checked,
  disabled,
}: {
  onClick: (e: React.MouseEvent<HTMLSpanElement>) => void;
  checked: boolean;
  disabled: boolean;
}) => {
  const handleClick = (e: React.MouseEvent<HTMLSpanElement>): void => {
    if (!disabled) {
      onClick(e);
    }
  };

  return (
    <Container $disabled={disabled}>
      <span>Show disabled schemas</span>
      <SwitchiOS
        isChecked={checked}
        onClick={handleClick}
        isDisabled={disabled}
        compact
      />
    </Container>
  );
};
